<div class="tab-box">
    <div class="title-ind">
      <h1 class="title-tab">Facturas</h1>
    </div>
    <div class="acciones-tabla">
      <!-- <app-input-tabla (keyup)="applyFilter($event)"></app-input-tabla> -->
      <div>
        <!-- <app-nueva-entidad (click)="openDialog()"></app-nueva-entidad> -->
        <app-descargar (click)="exportAsExcel()"></app-descargar>
      </div>
    </div>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      <ng-container matColumnDef="numeroFactura">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          Nº FACTURA
        </th>
        <td
        mat-cell
        *matCellDef="let factura"
      >
        {{ factura?.numeroFactura }}
      </td>
        
      </ng-container>
      <ng-container matColumnDef="numOperacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nº OPERACIÓN BANCO</th>
        <td
        mat-cell
        *matCellDef="let factura"
      >
        {{ factura?.numOperacion }}
      </td>
      </ng-container>
      <ng-container matColumnDef="concepto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>TIPO PRODUCTO</th>
        <td
        mat-cell
        *matCellDef="let factura"
      >
        {{ factura?.concepto }}
      </td>
      </ng-container>
      <ng-container matColumnDef="contratista.nombreComercial">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>CONTRATISTA</th>
        <td
        mat-cell
        *matCellDef="let factura"
      >
        {{ factura?.contratista?.nombreComercial }}
      </td>
      </ng-container>

      <ng-container matColumnDef="cliente.nombreComercial">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>CLIENTE</th>
        <td
        mat-cell
        *matCellDef="let factura"
      >
        {{ factura?.cliente?.nombreComercial }}
      </td>
      </ng-container>
      <ng-container matColumnDef="precioTotal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>IMPORTE</th>
        <td
        mat-cell
        *matCellDef="let factura"
      >
        {{ factura?.precioTotal }} €
      </td>
      </ng-container>
      <ng-container matColumnDef="fechaConfirmacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>FECHA PAGO</th>
        <td
        mat-cell
        *matCellDef="let factura"
      >
        {{ factura?.fechaConfirmacion | date:'dd/MM/YYYY'  }}
      </td>
      </ng-container>
      <ng-container matColumnDef="numeroLicencias">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nº LICENCIAS</th>
        <td
        mat-cell
        *matCellDef="let factura"
      >
        {{ factura?.numeroLicencias }}
      </td>
      </ng-container>
      <ng-container matColumnDef="descargar">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>DESCARGAR</th>
        <td mat-cell *matCellDef="let factura"><img src="./../../../../assets/descargar.png" alt="" (click)="generatePdf(factura.numeroFactura,factura.fechaConfirmacion,factura.numeroLicencias, factura.concepto, factura.precioUnitario,factura.baseImponible, factura.iva, factura.precioTotal, factura.formaPago, factura.contratista )"></td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 15, 20]"></mat-paginator>
  </div>
